import { Link } from 'react-router-dom';
import StarField from '../home/components/StarField';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Courses from '../home/components/Courses';
import { useLang } from '../../i18n/LanguageContext';

export default function CoursesPage() {
  const { t } = useLang();

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-[#1a0b2e] via-[#2d1b4e] to-[#1a0b2e] overflow-hidden">
      <StarField />
      <Navbar />

      {/* Hero */}
      <section className="relative z-10 pt-44 pb-20 px-4 sm:px-8 text-center overflow-hidden">
        <div className="absolute inset-0 opacity-20 pointer-events-none">
          <img
            src="https://public.readdy.ai/ai/img_res/d4eddd2c33f6be0afc5528fc7ab09f55.jpg"
            alt="bg"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1a0b2e]/60 via-transparent to-[#1a0b2e]"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-[#d4af37]/15 rounded-full border border-[#d4af37]/30 mb-8">
            <i className="ri-book-open-line text-[#d4af37] text-sm"></i>
            <span className="text-[#d4af37] text-sm font-medium">{t('SSD Mystic Academy', 'SSD 神秘学院')}</span>
          </div>

          <h1 className="text-4xl sm:text-6xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-[#d4af37] via-[#c8b6ff] to-[#d4af37] bg-clip-text text-transparent leading-tight">
            {t('Course Introduction', '课程介绍')}
          </h1>

          <p className="text-lg sm:text-xl text-[#c8b6ff] leading-relaxed mb-8 max-w-2xl mx-auto">
            {t(
              'Explore our professional occult courses — from tarot and astrology to magic — and begin your spiritual journey！',
              '探索我们专业神秘学课程——从塔罗、占星到魔法，开启你的灵性之路。'
            )}
          </p>


        </div>
      </section>

      {/* Category Filter Bar */}
      <section className="relative z-10 px-4 sm:px-8 pb-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap gap-3 justify-center">
            {[
              { en: 'All Courses', zh: '全部课程', icon: 'ri-apps-line' },
              { en: 'Divination', zh: '占卜系', icon: 'ri-magic-line' },
              { en: 'Healing', zh: '疗愈系', icon: 'ri-heart-pulse-line' },
              { en: 'Astrology', zh: '占星系', icon: 'ri-planet-line' },
              { en: 'Ritual', zh: '仪式系', icon: 'ri-fire-line' },
              { en: 'In-Person', zh: '面授课', icon: 'ri-map-pin-line' },
            ].map((cat) => (
              <button
                key={cat.en}
                className="flex items-center space-x-2 px-4 py-2 rounded-full bg-[#2d1b4e]/60 border border-[#d4af37]/20 text-[#c8b6ff] hover:border-[#d4af37]/60 hover:text-[#d4af37] transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
              >
                <i className={`${cat.icon} text-sm`}></i>
                <span>{t(cat.en, cat.zh)}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Courses Grid */}
      <Courses />

      {/* CTA Section */}
      <section className="relative z-10 py-20 px-4 sm:px-8 text-center">
        <div className="max-w-2xl mx-auto bg-gradient-to-br from-[#2d1b4e]/80 to-[#1a0b2e]/80 backdrop-blur-md rounded-3xl p-12 border border-[#d4af37]/20">
          <i className="ri-graduation-cap-line text-5xl text-[#d4af37] mb-6 block"></i>
          <h2 className="text-3xl font-bold text-white mb-4">
            {t("Ready to Begin Your Journey?", "准备好开启您的神秘学之旅了吗？")}
          </h2>
          <p className="text-[#c8b6ff] mb-8 leading-relaxed">
            {t(
              "Professional, system-based teaching has helped numerous students build a structured understanding of the occult",
              "专业体系化教学，已帮助众多学员建立系统的神秘学认知框架"
            )}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/membership"
              className="px-8 py-4 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-[#1a0b2e] font-bold rounded-full hover:shadow-lg hover:shadow-[#d4af37]/40 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              {t('View Membership', '查看会员体系')}
            </Link>
            <Link
              to="/academy"
              className="px-8 py-4 border border-[#d4af37]/50 text-[#d4af37] rounded-full hover:bg-[#d4af37]/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              {t('About Academy', '了解学院')}
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
